import AddIcon from "@mui/icons-material/Add";
import { MenuItem, Typography } from "@mui/material";
import { MenuPopover } from "@styleguide";
import type { IMenuPopoverProps } from "@surfaces/MenuPopover";
import { useState } from "react";

export interface ICreateWithAIDropdownProps
  extends Partial<Omit<IMenuPopoverProps, "label" | "children" | "ButtonProps" | "open" | "onOpen" | "onClose">> {
  label: string;
  createLabel: string;
  importLabel: string;
  onCreateManually: () => void;
  onImportWithAI: () => void;
  buttonProps?: IMenuPopoverProps["ButtonProps"];
}

export const CreateWithAIDropdown = ({
  label,
  createLabel,
  importLabel,
  onCreateManually,
  onImportWithAI,
  buttonProps,
  ...menuPopoverProps
}: ICreateWithAIDropdownProps) => {
  const [open, setOpen] = useState(false);

  const handleCreateManually = () => {
    setOpen(false);
    onCreateManually();
  };

  const handleImportWithAI = () => {
    setOpen(false);
    onImportWithAI();
  };

  return (
    <MenuPopover
      label={label}
      variant="contained"
      {...menuPopoverProps}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      ButtonProps={{ startIcon: <AddIcon />, ...buttonProps }}
    >
      <MenuItem onClick={handleCreateManually}>
        <Typography variant="body1">{createLabel}</Typography>
      </MenuItem>
      <MenuItem onClick={handleImportWithAI}>
        <Typography variant="body1">{importLabel}</Typography>
      </MenuItem>
    </MenuPopover>
  );
};
